import { createSlice } from "@reduxjs/toolkit";

const storedData =
  typeof window !== "undefined" && localStorage.getItem("swayamCreatorData")
    ? JSON.parse(localStorage.getItem("swayamCreatorData"))
    : null;

const initialState = {
  creator: storedData ? storedData.creator : null,
  token: storedData ? storedData.token : null,
};

const swayamCreatorSlice = createSlice({
  name: "swayamCreator",
  initialState,
  reducers: {
    setSwayamCreator: (state, action) => {
      state.creator = action.payload;
    },
    setSwayamToken: (state, action) => {
      state.token = action.payload;
    },
    swayamCreatorLogout: (state) => {
      state.creator = null;
      state.token = null;
      localStorage.removeItem("swayamCreatorData");
    },
  },
});

export const { setSwayamCreator, setSwayamToken, swayamCreatorLogout } =
  swayamCreatorSlice.actions;
export default swayamCreatorSlice.reducer;
